import React from 'react';
import styles from './TypeMovements.module.scss';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CountUp from 'react-countup';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 0,
  // [`&.${linearProgressClasses.colorPrimary}`]: {
  //     backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 800 : 100],
  // },
  // [`& .${linearProgressClasses}`]: {
  //     borderRadius: 0,
  //     backgroundColor: theme.palette.mode === 'light' ? '#ccc' : '#C22EDA',
  // },
}));

const TypeMovements = () => (
  <div className={styles.TypeMovements} data-testid="TypeMovements">
    <Card sx={{ padding: 0, boxShadow: 0 }} >
                          <CardHeader sx={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 1, }} action={
                              <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }} >
                                  {/* <SettingsSuggestIcon /> */}
                              </IconButton>
                          }
                              title="Type of Movements" />
                          <Divider />
                          <CardContent sx={{ paddingLeft: 0, paddingRight: 0, }}>
                              <Stack spacing={1} direction="row" useFlexGap flexWrap="wrap">

                                  <Box sx={{ backgroundColor: 'primary.dark', color: 'primary.contrastText' }}>
                                      <Box className="box-tile" sx={{ padding: 2 }}>
                                          <Typography gutterBottom variant="body2" color="text.primary.contrastText">
                                              Direct
                                          </Typography>
                                          <Typography variant="h5" component="h1"   >
                                              <CountUp end={40} duration={1} enableScrollSpy />
                                          </Typography>
                                      </Box>

                                      <BorderLinearProgress variant="determinate" color='secondary' value={30} />
                                  </Box>
                                  <Box sx={{ backgroundColor: 'primary.dark', color: 'primary.contrastText' }}>
                                      <Box className="box-tile" sx={{ padding: 2 }}>
                                          <Typography gutterBottom variant="body2" color="text.primary.contrastText">
                                              Collections
                                          </Typography>
                                          <Typography variant="h5" component="h1"   >
                                              <CountUp end={200} duration={1} enableScrollSpy />
                                          </Typography>
                                      </Box>

                                      <BorderLinearProgress variant="determinate" color='secondary' value={60} />
                                  </Box>
                                  <Box sx={{ backgroundColor: 'primary.dark', color: 'primary.contrastText' }}>
                                      <Box className="box-tile" sx={{ padding: 2 }}>
                                          <Typography gutterBottom variant="body2" color="text.primary.contrastText">
                                              Shuttles
                                          </Typography>
                                          <Typography variant="h5" component="h1"   >
                                              <CountUp end={25} duration={1} enableScrollSpy />
                                          </Typography>
                                      </Box>
                                      <BorderLinearProgress variant="determinate" color='secondary' value={60} />
                                  </Box>
                                  <Box sx={{ backgroundColor: 'primary.dark', color: 'primary.contrastText' }}>
                                      <Box className="box-tile" sx={{ padding: 2 }}>
                                          <Typography gutterBottom variant="body2" color="text.primary.contrastText">
                                              Deliveries
                                          </Typography>
                                          <Typography variant="h5" component="h1"   >
                                              <CountUp end={40} duration={1} enableScrollSpy />
                                          </Typography>
                                      </Box>
                                      <BorderLinearProgress variant="determinate" color='neutral' value={60} />
                                  </Box>

                              </Stack>


                          </CardContent>
                      </Card>

  </div>
);

export default TypeMovements;